<template>
    <div>
        {{max}}
        <span class="slider-wrapper">
            <input type="range" :min="min" :max="max" :value="value" @input="onValueChange">
        </span>
        {{min}}
    </div>
</template>

<script>
export default {
  name: 'RangeSlider',
  props: {imgId: String, value: String|Number, max: String, min: String},
  methods: {
  onValueChange({target}) {
    this.$emit('input', this.imgId, target.value);
  }
}
}
</script>

<style scoped>

.slider-wrapper {
  display: inline-block;
  width: 33px;
  height: 15vh;
  padding: 0;
  margin: 0.5em 25px;
}
input[type="range"] {
  -webkit-appearance: none;
  width:15vh;
  height:33px;
  transform-origin: 0 0;
  transform: rotate(90deg);
  margin: 0 19px;
  background: rgba(0,0,0,0);
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  box-shadow: 0px 0px 3.8px #000000, 0px 0px 0px #0d0d0d;
  background: rgba(0, 0, 0, 0.53);
  border-radius: 4.6px;
  border: 1.1px solid rgba(1, 1, 1, 0.19);
}
input[type=range]::-webkit-slider-thumb {
  box-shadow: 1.8px -1.8px 3.7px rgba(0, 0, 0, 0.72), 0px 0px 1.8px rgba(13, 13, 13, 0.72);
  border: 1px solid #d1bfb5;
  height: 32px;
  width: 32px;
  border-radius: 16px;
  background: linear-gradient(to right, #d09156 0%,#B87333 100%);
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -14px;
}

input[type=range]::-moz-range-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  box-shadow: 0px 0px 3.8px #000000, 0px 0px 0px #0d0d0d;
  background: rgba(0, 0, 0, 0.53);
  border-radius: 4.6px;
  border: 1.1px solid rgba(1, 1, 1, 0.19);
}
input[type=range]::-moz-range-thumb {
  box-shadow: 1.8px -1.8px 3.7px rgba(0, 0, 0, 0.72), 0px 0px 1.8px rgba(13, 13, 13, 0.72);
  border: 1px solid #d1bfb5;
  height: 32px;
  width: 32px;
  border-radius: 16px;
  background: linear-gradient(to right, #d09156 0%,#B87333 100%);
  cursor: pointer;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 11px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: rgba(0, 0, 0, 0.53);
  border: 1.1px solid rgba(1, 1, 1, 0.19);
  border-radius: 9.2px;
  box-shadow: 0px 0px 3.8px #000000, 0px 0px 0px #0d0d0d;
}
input[type=range]::-ms-fill-upper {
  background: rgba(0, 0, 0, 0.53);
  border: 1.1px solid rgba(1, 1, 1, 0.19);
  border-radius: 9.2px;
  box-shadow: 0px 0px 3.8px #000000, 0px 0px 0px #0d0d0d;
}
input[type=range]::-ms-thumb {
  box-shadow: 1.8px 1.8px 3.7px rgba(0, 0, 0, 0.72), 0px 0px 1.8px rgba(13, 13, 13, 0.72);
  border: 1px solid #d1bfb5;
  height: 32px;
  width: 32px;
  border-radius: 16px;
  background: #d9beb4;
  cursor: pointer;
  height: 11px;
}
input[type=range]:focus::-ms-fill-lower {
  background: rgba(0, 0, 0, 0.53);
}
input[type=range]:focus::-ms-fill-upper {
  background: rgba(3, 3, 3, 0.53);
}

</style>
